import { ThemeConfig, theme } from 'antd';
import { typography } from './typography';
import { tokens } from './tokens';

export const customTheme: ThemeConfig = {
  token: {
    fontFamily: typography.fontFamilies.dmSans,
    fontSize: 14,
    colorBgBase: '#ffffff',
    colorTextBase: tokens.colors.primary.neutral[900],
    colorPrimary: tokens.colors.brand.blue,
    colorSuccess: tokens.colors.supporting.green[600],
    colorWarning: tokens.colors.supporting.yellow[600],
    colorError: tokens.colors.supporting.red[600],
    colorBgLayout: tokens.colors.primary.neutral[50],
    fontSizeHeading1: 24,
    fontSizeHeading2: 20,
    fontSizeHeading3: 16,
    fontSizeHeading4: 14,
    lineHeightHeading1: typography.heading.xl.lineHeight,
    lineHeightHeading2: typography.heading.lg.lineHeight,
    lineHeightHeading3: typography.heading.md.lineHeight,
    lineHeightHeading4: typography.heading.sm.lineHeight,
    borderRadius: 10
  },

  algorithm: theme.defaultAlgorithm,

  components: {
    Button: {
      algorithm: true,
      borderRadius: 10,
      colorPrimary: tokens.colors.brand.blue,
      colorPrimaryHover: 'rgb(71, 83, 151)',
      colorPrimaryActive: 'rgb(41, 53, 111)'
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: 'rgba(51, 63, 131, 0.08)',
      itemSelectedColor: tokens.colors.brand.blue,
      itemHoverColor: tokens.colors.brand.blue,
    },
    Modal: {
      contentBg: '#ffffff',
      headerBg: '#ffffff'
    },
    Card: {
      colorBgContainer: '#ffffff'
    },
    Tag: {
      borderRadiusSM: 6
    },
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#f8f9fa',
    }
  }
};
